import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function formatDate(date: string, dateFormat: string = "YYYY-MM-DD") {
  if (!date) return "";
  const localTimezone = dayjs.tz.guess();
  return dayjs(date).tz(localTimezone).format(dateFormat);
}
export const STATUS_CONFIG_ADMIN: Record<
  string,
  { label: string; bg: string; text: string; padding: string }
> = {
  init: { label: "초기화", bg: "bg-black/[0.06]", text: "text-[#202020]", padding: "px-[12.5px]" },
  in_progress: {
    label: "진행 중",
    bg: "bg-[#FFAA72]",
    text: "text-[#000000]",
    padding: "px-[14.5px]",
  },
  under_review: {
    label: "검토 중",
    bg: "bg-[#E0B244]",
    text: "text-[#000000]",
    padding: "px-[12.5px]",
  },
  completed: {
    label: "완료",
    bg: "bg-[#43946C]",
    text: "text-[#000000]",
    padding: "px-[21px]",
  },
  rejected: {
    label: "거부됨",
    bg: "bg-[#CB3A31]",
    text: "text-[#000000]",
    padding: "px-[14.5px]",
  },
  deleted: {
    label: "삭제됨",
    bg: "bg-[#EBEBEB]",
    text: "text-[#000000E8]",
    padding: "px-[14.5px]",
  },
};

export const STATUS_CONFIG_INQUIRY: Record<
  string,
  { label: string; bg: string; text: string; padding: string }
> = {
  in_progress: {
    label: "처리 중",
    bg: "bg-[#FFAA72]",
    text: "text-[#000000]",
    padding: "px-[12.5px]",
  },
  completed: {
    label: "답변완료",
    bg: "bg-[#43946C]",
    text: "text-[#000000]",
    padding: "px-2",
  },
  deleted: {
    label: "삭제됨",
    bg: "bg-[#EBEBEB]",
    text: "text-[#000000E8]",
    padding: "px-[14.5px]",
  },
};

export function getCategoryType(category: string): string {
  const lower = category.toLowerCase();
  if (lower.includes("horizontal")) return "horizontal";
  if (lower.includes("vertical")) return "vertical";
  if (lower.includes("enabler")) return "enabler";
  return "horizontal";
}
export function formatPhoneNumber(phone: string, international: boolean = true): string {
  const digits = phone.replace(/\D/g, "");

  // Korean mobile: strip leading 82 if present, then rebuild with leading 0
  let local = digits;
  if (local.startsWith("82") && local.length >= 11) {
    local = "0" + local.slice(2);
  }

  // Format as Korean mobile: 01X-XXXX-XXXX
  if (local.startsWith("01") && local.length >= 10) {
    const prefix = local.slice(0, 3);
    const part1 = local.slice(3, 7);
    const part2 = local.slice(7, 11);
    if (international) {
      return `+82 ${prefix.slice(1)}-${part1}-${part2}`;
    }
    return `${prefix}-${part1}-${part2}`;
  }

  // Fallback: return as-is if it doesn't match Korean mobile pattern
  return phone;
}

/**
 * Shorten a UUID for display: "a3f1b2c4-d5e6-..." -> "A3F1B2C4" (default 8 chars)
 * 8 hex chars = 4.3B combos. Collision risk is negligible for display purposes
 * since the full ID remains available via copy-to-clipboard / tooltip.
 */
export function shortId(id: string, length: number = 8): string {
  if (!id) return "";
  return id.replace(/-/g, "").slice(0, length).toUpperCase();
}

export const MAIN_CATEGORY_LABELS: Record<string, string> = {
  horizontal: "Horizontal (General/Business Support)",
  vertical: "Vertical (Industry-Specific)",
  enabler: "Enabler (Platform/Infrastructure)",
};
